import { useState } from "react";
import VisacostpaymentPopUp from "./visacostpaymentPopUp";
import { CgEye } from "react-icons/cg";
import { BsCloudUploadFill } from "react-icons/bs";
import { FaArrowCircleDown } from "react-icons/fa";
import DownloadPopUp from "./downloadPDF_POPUP";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import CancelPop_Up from "./Cancel_flow_PopUp";
import DownloadPopUp_VisaCost from "./downloadPDFVisa_cost";

export default function VisacosttableModule({
  summaryData,
  propData,
  setTrigger,
  setSelectedId,
  quotationType,
  selectedId,
  trigger,
  setSelectedValue,
  SetDownloadPDF,
  setData1,
  setData2,
}) {
  console.log("Data to be seen here.....nnn.....", summaryData);
  const dispatch = useDispatch();
  const row = [
    {
      id: 1,
      name: "YTC",
    },
  ];
  const rowsData = [
    {
      id: 1,
      name: "YTC",
    },
    {
      id: 2,
      name: "YTC",
    },
    {
      id: 3,
      name: "YTC",
    },
    {
      id: 4,
      name: "YTC",
    },
    {
      id: 4,
      name: "YTC",
    },
  ];
  const tableHeading = [
    {
      rate_category_id: 1,
      title: "EMPLOYEE SALARY PACKAGE",
      bgPrimary: "bg-gray",
      bgSecondary: "bg-gray",
    },
  ];

  const tableProperties = {
    colWidth: "w-56",
    colHeight: "h-[2rem]",
    itemHeight: "h-[3rem]",
  };
  const tableProperties2 = {
    colWidth: "w-28",
    colHeight: "h-[2rem]",
    itemHeight: "h-[3rem]",
  };
  const [showPromptElement, setshowPromptElement] = useState(false);
  const [propsData, setPropsData] = useState();
  const handleClick = (data) => {
    setPropsData(data);
    setshowPromptElement(true);
  };

  const [checked, setChecked] = useState(false);

  const [indexValue, setIndexValue] = useState();

  // const handleCheckboxChange = (id, index) => {
  //   const isChecked = summaryData?.data.some((data) => data.id === id);
  //   if (isChecked) {
  //     setIndexValue(index);
  //     setSelectedId(id);
  //   }
  //   setChecked(isChecked);
  // };

  // const [selectedData,setSelectedData] = useState([])

  const handleCheckboxChange = (event, id, index, data) => {
    const isChecked = event.target.checked;

    setSelectedId((prevState) => {
      if (isChecked) {
        // If the checkbox is checked, select the ID
        setSelectedValue(data);
        return [id];
      } else {
        // If the checkbox is unchecked, deselect the ID
        setSelectedValue([]);
        return [];
      }
    });
  };

  console.log("indexValue....indexValue", selectedId);

  const [downloadPopUp, setDownloadPopUp] = useState(false);

  const [downloadData, setDownloadData] = useState();
  const [summaryProp, setSummaryProp] = useState();
  const token = localStorage.getItem("nodeToken");

  const getData = async () => {
    try {
      const response = await nodeinstance.get(
        `/dashboard/visaSecurity/costplusproformaInvoice/${summaryData?.contractData?.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        console.log(
          "Data to be seen here.....sssss..s.s.s..s..s.s.s.s..s.s.s.ss..s.s.s",
          response
        );
        setSummaryProp(response?.data?.data);
        setData1(response?.data?.data);
      }
    } catch (error) {
      console.log("error to be seen here...", error);
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  useEffect(() => {
    if (summaryData?.contractData?.id) {
      getData();
    }
  }, [downloadPopUp, summaryData]);
  const [newPop, setNewPop] = useState(false);

  const [day, setDay] = useState();

  const handleDownloadClickTwo = (data) => {
    setDownloadPopUp(true);
    setDay(data);
    setData2(data);
  };

  // const handleDownloadClick = async (data) => {
  //   setNewPop(true);
  //   setDownloadData(data);
  // };

  const handleDownloadClick = async (data) => {
    // Set the state with the modified data
    setNewPop(true);
    setDownloadData(data);
    setData2(data);
  };

  const secClick = (data) => {
    setDownloadPopUp(true);
    setDownloadData(data);
  };

  const [cancelPopUp, setCancelPopUp] = useState(false);

  const handleCnacelPopUpClick = (data) => {
    setPropsData(data);
    setCancelPopUp(true);
  };
  console.log("downlaodData and summaryProp to be seen here...", downloadData);
  function formatDate(dateString) {
    const date = new Date(dateString);
    const monthNames = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];

    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    const formattedDate = `${day}-${monthNames[monthIndex]}-${year}`;
    return formattedDate;
  }
  return (
    <>
      <div className="!uppercase">
        <p className="ml-10">INVOICE SUMMARY</p>
        <div
          className="flex flex-col w-full gap-1 my-2 overflow-x-scroll pl-16 pt-2"
          style={summaryData?.data?.length > 4 ? { height: "250px" } : {}}
        >
          <div className="flex">
            {row.map((section, sectionIndex) => (
              <div className="flex flex-col relative" key={sectionIndex}>
                {sectionIndex == 0 && (
                  <>
                    <div className={`flex w-full gap-1 `}>
                      <>
                        {/* {quotationType === "Cost Plus" ? ( */}
                        {/* <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties2.colWidth} ${tableProperties2.itemHeight}`}
                        >
                          Invoice
                        </h3> */}

                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties2.colWidth} ${tableProperties2.itemHeight}`}
                        >
                          SL. NO.
                        </h3>

                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties2.colWidth} ${tableProperties2.itemHeight}`}
                        >
                          MONTHS
                        </h3>

                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties2.colWidth} ${tableProperties2.itemHeight}`}
                        >
                          QUANTITY
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          Invoice TYPE
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          REQUEST/INVOICE.NO
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          Invoice_Created_Date
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          INVOICE AMOUNT
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          INVOICE SENT DATE
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          AMOUNT RECEIVED
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          CREDIT NOTE
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          BALANCE AMOUNT
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          AMOUNT RECEIVED SPLIT
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          Upload Invoice
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          Action
                        </h3>
                      </>
                    </div>
                  </>
                )}
                <div className="mb-2">
                  {summaryData?.data?.map((data, index) => (
                    <div
                      className="flex w-full gap-1 relative mb-2 mt-2"
                      key={index}
                    >
                      {/* <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                      >
                        <input
                          type="checkbox"
                          key={data.id}
                          onChange={(event) => {
                            handleCheckboxChange(event, data.id, index, data);
                          }}
                          checked={selectedId.some((item) => item === data.id)}
                          className="mr-2"
                        />
                      </p> */}

                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                      >
                        {index + 1}
                      </p>

                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                      >
                        {data.months === 0 ? "N/A" : data.months}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                      >
                        {data.quantity}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {data.cost_type}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {data.invoice_number}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {/* {data.created_at
                          ? new Date(data.created_at)
                              .toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              .split(" ")
                              .map((part, index) =>
                                index === 1 ? part.toUpperCase() : part
                              )
                              .join("-")
                          : "-----"} */}
                        {data.created_at
                          ? formatDate(data.created_at)
                          : "-----"}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {/* {parseFloat(data.invoice_amount)} */}
                        {parseFloat(data.invoice_amount).toFixed(2)}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {/* {data.invoices_sent_date} */}
                        {data.invoices_sent_date
                          ? formatDate(data.invoices_sent_date)
                          : "-----"}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {0}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {data.credit_note_amount ? data.credit_note_amount : 0}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {parseInt(data.invoice_amount) -
                          (parseInt(
                            data.credit_note_amount
                              ? data.credit_note_amount
                              : 0
                          ) +
                            parseInt(
                              data.amount_received ? data.amount_received : 0
                            ))}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {"YTC"}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        style={{
                          cursor:
                            data.invoice_status === "INACTIVE" ? "" : "pointer",
                        }}
                      >
                        {data &&
                        data.invoice_amount === data.credit_note_amount ? (
                          "FULL PAYMENT RECEIVED"
                        ) : data.invoice_status === "INACTIVE" ? (
                          <BsCloudUploadFill />
                        ) : (
                          <BsCloudUploadFill
                            size={"1rem"}
                            onClick={() => {
                              handleClick(data);
                            }}
                          />
                        )}
                      </p>
                      {data.invoice_status === "INACTIVE" ? (
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          <h2>CANCELLED</h2>
                        </p>
                      ) : data.cost_type === "SEC DEPOSIT" ? (
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          style={{ cursor: "pointer" }}
                        >
                          <FaArrowCircleDown
                            className="mr-4"
                            size={"1.5rem"}
                            onClick={() => {
                              handleDownloadClick(data);
                            }}
                          />{" "}
                          <CgEye
                            size={"1.5rem"}
                            onClick={() => {
                              handleCnacelPopUpClick(data);
                            }}
                          />
                        </p>
                      ) : (
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          style={{ cursor: "pointer" }}
                        >
                          <FaArrowCircleDown
                            className="mr-4"
                            size={"1.5rem"}
                            onClick={() => {
                              handleDownloadClickTwo(data);
                            }}
                          />{" "}
                          <CgEye
                            size={"1.5rem"}
                            onClick={() => {
                              handleCnacelPopUpClick(data);
                            }}
                          />
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        {showPromptElement ? (
          <VisacostpaymentPopUp
            showPromptElement={showPromptElement}
            setshowPromptElement={setshowPromptElement}
            propsData={propsData}
            setTrigger={setTrigger}
            trigger={trigger}
          />
        ) : (
          ""
        )}
        {newPop ? (
          <DownloadPopUp_VisaCost
            downloadPopUp={newPop}
            setDownloadPopUp={setNewPop}
            downloadData={downloadData}
            summaryProp={summaryProp}
            SetDownloadPDF={SetDownloadPDF}
          />
        ) : (
          ""
        )}
        {downloadPopUp ? (
          <DownloadPopUp_VisaCost
            downloadPopUp={downloadPopUp}
            setDownloadPopUp={setDownloadPopUp}
            downloadData={day}
            summaryProp={summaryProp}
            SetDownloadPDF={SetDownloadPDF}
          />
        ) : (
          ""
        )}
        {cancelPopUp ? (
          <CancelPop_Up
            cancelPopUp={cancelPopUp}
            setCancelPopUp={setCancelPopUp}
            setTrigger={setTrigger}
            trigger={trigger}
            propsData={propsData}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
}
